export function isErrorLike(obj: unknown): obj is { message: string } {
  // @ts-expect-error fix later
  return obj && typeof obj === "object" && typeof obj.message === "string";
}
